import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { NAME_SPACE } from 'i18n';
import { PATH } from 'app.routes.const';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { UserContext, ROLES } from 'auth';
import { useListExperiencesStyles } from './listExperiences.styles';
import { useExperiencesPaginated } from './useExperiencesPaginated';
import { useExperiencesBuildTable } from './useExperiencesBuildTable';

export function ListExperiences() {
  const classes = useListExperiencesStyles();
  const { experiences, getExperiences, deleteExperiences, copyExperience, errorInfo } = useExperiencesPaginated();
  const { t } = useTranslation(NAME_SPACE.EXPERIENCES);
  const history = useHistory();
  const { user } = useContext(UserContext);
  const isReadOnly = user.role === ROLES.ANALYTICS;

  const { rows, headCells } = useExperiencesBuildTable(experiences, t);

  function handleEdit([experienceId]) {
    history.push(PATH.EXPERIENCES.EDIT.replace(':id', experienceId));
  }

  function handleAdd() {
    history.push(PATH.EXPERIENCES.CREATE);
  }

  async function handleDelete(experiencesToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          experiencesToDelete.length > 1
            ? t('removeConfirm.message', { length: experiencesToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: experiencesToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteExperiences(experiencesToDelete);
    } catch (err) {}
  }

  async function handleCopy([experienceId]) {
    await copyExperience(experienceId);
  }

  return (
    <div className={classes.experiences}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getExperiences}
        totalRows={experiences.total}
        selectRowWhen={element => element.canBeDeleted}
        allowRowSelection={!isReadOnly}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          },
          ...(!isReadOnly
            ? [
                {
                  title: t('actions.copy'),
                  name: 'copy',
                  properties: ['id'],
                  label: 'copy this row',
                  cb: handleCopy,
                  icon: <FileCopyIcon />
                }
              ]
            : [])
        ]}
        toolbar={{
          title: t('name'),
          actions: isReadOnly
            ? []
            : [
                {
                  condition: isAnySelected => !isAnySelected,
                  cb: handleAdd,
                  component: ButtonAdd
                },
                {
                  condition: isAnySelected => isAnySelected,
                  resetOnCB: true,
                  cb: handleDelete,
                  component: ButtonDelete
                }
              ]
        }}
      />
    </div>
  );
}
